import './TextEditor.vendor.css';
import Quill from 'quill';

import Divider from './formats/divider';
import SnowTheme from './themes/snow';

// Register under a custom name so we don't clobber Quill's built-in 'snow' theme
// globally. The Stash theme no-ops `buildButtons` (the Stash TextEditor renders its
// own Vue buttons with SVG slots). If we registered as 'themes/snow', any other Quill
// wrapper in the same bundle (e.g. PrimeVue's <Editor>) would also lose its toolbar
// icons because they rely on `buildButtons` to stamp SVGs into empty buttons.
Quill.register(
  {
    'formats/divider': Divider,
    'themes/stash-snow': SnowTheme,
  },
  true,
);
